import "lazysizes";
import "./cookie-consent";
import { createCountUpObserver, initProjectsAnimation, initAboutIntroAnimation, initProjectsIntroAnimation, initIntroContactAnimation, initAboutGhostAnimation, initContactAnimation, initProcessAnimation } from "./animation";
import { initFeatures } from "./features";

import "./auftrags-finder";

import Splitting from "splitting";

const faqItems = document.querySelectorAll(".faq__card");

faqItems.forEach((card) => {
  card.addEventListener("click", (e) => {
    const isOpen = e.currentTarget.classList.contains("faq__card--open");

    // Alle anderen schließen
    faqItems.forEach((c) => {
      c.classList.remove("faq__card--open");
      c.setAttribute("aria-expanded", "false");
    });

    // Aktuelles Element umschalten
    if (!isOpen) {
      e.currentTarget.classList.add("faq__card--open");
      e.currentTarget.setAttribute("aria-expanded", "true");
    }
  });
});

// Initialisieren des CountUp Observers beim Laden der Seite
document.addEventListener("DOMContentLoaded", createCountUpObserver);

Splitting({
  /* target: String selector, Element, Array of Elements, or NodeList */
  target: "[data-splitting]",
  /* by: String of the plugin name */
  by: "chars",
  /* key: Optional String to prefix the CSS variables */
  key: null,
});

// Initialisiere alle Scroll-Animationen
initFeatures();
initProjectsAnimation();
initAboutIntroAnimation();
initProjectsIntroAnimation();
initAboutGhostAnimation();
initContactAnimation();
initProcessAnimation();

// Intro Contact Animation wird nach introEnd Event initialisiert
document.addEventListener("introEnd", function (e) {
  initIntroContactAnimation();
});

// Smooth Scroll für Contact Links
const anchors = document.querySelectorAll('a[data-contact-link="root"]');

if (anchors.length > 0) {
  anchors.forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      const targetID = this.getAttribute("href");

      if (targetID) {
        const targetElement = document.querySelector(targetID);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    });
  });
}

const $navBtn = document.querySelector(".header__menu-text");
const $closeBtn = document.querySelector(".header__close-btn");
const $navWrapper = document.querySelector(".header__nav-wrapper");
const $nav = document.querySelector(".header__nav");

if ($navBtn && $closeBtn && $nav) {
  $navBtn.addEventListener("click", () => {
    $navBtn.classList.toggle("header__menu-text--open");
    triggerGoveeLamp();
  });

  $closeBtn.addEventListener("click", () => {
    $navBtn.classList.remove("header__menu-text--open");
    triggerGoveeLamp();
  });

  document.addEventListener("click", (e) => {
    const isMenuOpen = $navBtn.classList.contains("header__menu-text--open");
    const clickedInsideNav = $nav.contains(e.target);

    if (isMenuOpen && !clickedInsideNav) {
      $navBtn.classList.remove("header__menu-text--open");
    }
  });
}

// Projekt-Anfrage Formular Handler
const projektForm = document.querySelector("[data-projekt-form]");
const projektSuccess = document.querySelector("[data-projekt-success]");

if (projektForm) {
  // Radio Button Selection State
  const radioLabels = projektForm.querySelectorAll(".projekt-anfrage__radio");
  radioLabels.forEach((label) => {
    const input = label.querySelector("input[type='radio']");
    if (input) {
      input.addEventListener("change", () => {
        radioLabels.forEach((l) => l.classList.remove("projekt-anfrage__radio--selected"));
        if (input.checked) {
          label.classList.add("projekt-anfrage__radio--selected");
        }
      });
    }
  });
}

if (projektForm && projektSuccess) {
  projektForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(projektForm);

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });

      if (response.ok) {
        projektForm.style.display = "none";
        projektSuccess.style.display = "block";
        projektSuccess.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        alert("Es gab einen Fehler. Bitte versuche es erneut.");
      }
    } catch (error) {
      console.error("Formular Fehler:", error);
      alert("Es gab einen Fehler. Bitte versuche es erneut.");
    }
  });
}

// Govee Bürolampe mit zufälliger Farbe triggern
function triggerGoveeLamp() {
  fetch("/.netlify/functions/govee-light", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        console.log("🌈 Bürolampe Farbe:", data.color.hex);
      }
    })
    .catch((err) => console.log("Govee API Fehler:", err));
}
